import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { LASFile } from '../db/LASFile';

export const getBundleFilesByReferenceID = registerQuery({
  type: () => [LASFile],
  operationName: 'getBundleFilesByReferenceID',
  resolve: (referenceID: string) => {
    return async (gqlFields: BaseQLSelectionSet<LASFile>) => {
      const rawFileCollection = await getRawCollection<LASFile>(LASFile._collectionName);
      const bundleFiles = await rawFileCollection
        .find<LASFile>({ 'bundleMeta.fileReferenceID': referenceID })
        .toArray();
      return bundleFiles;
    };
  },
  params: [{ name: 'referenceID', type: () => String }],
});
